export default[
    {
        title: 'Mes tutos',
        icon: 'InfoIcon',
        route: 'faqs-lists',
        typeUser: 'courtier',
    }
]
